module.exports = __webpack_public_path__ + "img/img12.f3e51ef5.svg";